"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationSerializer = void 0;
class ConfigurationSerializer {
    serialize(data) {
        return {
            ga: data.ga ? this.serializeGoogleAnalytics(data.ga) : undefined,
            analytics: data.analytics ? this.serializeAnalyticsConfiguration(data.analytics) : undefined,
        };
    }
    serializeGoogleAnalytics(ga) {
        return {
            trackId: ga.trackId,
        };
    }
    serializeAnalyticsConfiguration(analytics) {
        return {
            dpAnalyticsEndpoint: analytics.dpAnalyticsEndpoint,
            dpAnalyticsKey: analytics.dpAnalyticsKey,
            avrMessage: analytics.avrMessage,
        };
    }
}
exports.ConfigurationSerializer = ConfigurationSerializer;
//# sourceMappingURL=configuration.serializer.js.map